import { Instance } from 'mobx-state-tree';
import { RouteStopReschedulingDtoModelBase } from './RouteStopReschedulingDtoModel.base';

/* The TypeScript type of an instance of RouteStopReschedulingDtoModel */
export interface RouteStopReschedulingDtoModelType extends Instance<typeof RouteStopReschedulingDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopReschedulingDtoModel */
export { selectFromRouteStopReschedulingDto, routeStopReschedulingDtoModelPrimitives, RouteStopReschedulingDtoModelSelector } from './RouteStopReschedulingDtoModel.base';

/**
 * RouteStopReschedulingDtoModel
 *
 * Route rescheduling event
 */
export const RouteStopReschedulingDtoModel = RouteStopReschedulingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
